module.exports = __webpack_public_path__ + "img/cake-17.ddcc54e4.svg";